export const TYPE_ORDINARY = 'ordinary';
export const TYPE_SEASON = 'seasonal';

export default {
    TYPE_ORDINARY,
    TYPE_SEASON
}